export const RATIO_HEIGHT_PIXEL_TO_REAL_SIZE = 0.25;
